"use client";

import { usePathname } from "next/navigation";
import { Footer } from "./footer";

export function FooterWrapper() {
  const pathname = usePathname();

  // Do not render footer on dashboard, auth, signup, api, or live interview routes
  // Also exclude resume builder or other full-screen application views if they exist
  const path = pathname ?? "";
  const shouldHideFooter =
    path.startsWith("/dashboard") ||
    path.startsWith("/auth") ||
    path.startsWith("/signup") ||
    path.startsWith("/request-access") ||
    path.startsWith("/api") ||
    path.startsWith("/resume/builder") ||
    // The apply flow is a self-contained full-screen funnel with its own fixed
    // header; the marketing footer below it is a phantom (double-chrome). The
    // (app) route group is stripped, so usePathname() returns "/apply/[jobId]"
    // (and the "/apply/[jobId]/success" child) here.
    path.startsWith("/apply") ||
    // The recruiter inbox is a viewport-locked 3-column app; the marketing
    // footer below it creates a phantom scrollbar. The (app) route group is
    // stripped from the URL, so usePathname() returns "/admin/inbox" here.
    // The prefix also covers "/admin/inbox/[conversationId]".
    path.startsWith("/admin/inbox") ||
    /^\/interview\/[^/]+$/.test(path);

  if (shouldHideFooter) {
    return null;
  }

  return <Footer />;
}
